import Text from './index.vue'

export default Text
